module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Widgets\n      "), _c('small', [_vm._v("Preview page")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Widgets")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Messages")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("1,410")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("410")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Uploads")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("13,648")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("93,139")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-aqua"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-green"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-yellow"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Events")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-red"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("150")]), _vm._v(" "), _c('p', [_vm._v("New Orders")])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            More info "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-green"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("53"), _c('sup', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Bounce Rate")])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-stats-bars"
  })]), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            More info "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-yellow"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("44")]), _vm._v(" "), _c('p', [_vm._v("User Registrations")])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-person-add"
  })]), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            More info "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("65")]), _vm._v(" "), _c('p', [_vm._v("Unique Visitors")])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-pie-graph"
  })]), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            More info "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-default collapsed-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-danger"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-default collapsed-box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-success box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-warning box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-danger box-solid"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary direct-chat direct-chat-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge bg-light-blue",
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, [_c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type Message ..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-success direct-chat direct-chat-success"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge bg-green",
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, [_c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type Message ..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge bg-yellow",
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, [_c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type Message ..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-danger direct-chat direct-chat-danger"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge bg-red",
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, [_c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "Message User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type Message ..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Social Widgets")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-widget widget-user-2"
  }, [_c('div', {
    staticClass: "widget-user-header bg-yellow"
  }, [_c('div', {
    staticClass: "widget-user-image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/user7-128x128.jpg",
      "alt": "User Avatar"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Nadia Carmichael")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Lead Developer")])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Projects "), _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tasks "), _c('span', {
    staticClass: "pull-right badge bg-aqua"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Completed Projects "), _c('span', {
    staticClass: "pull-right badge bg-green"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Followers "), _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_vm._v("842")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-widget widget-user"
  }, [_c('div', {
    staticClass: "widget-user-header bg-aqua-active"
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Founder & CEO")])]), _vm._v(" "), _c('div', {
    staticClass: "widget-user-image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("PRODUCTS")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-widget widget-user"
  }, [_c('div', {
    staticClass: "widget-user-header bg-black",
    staticStyle: {
      "background": "url('/static/img/photo1.png') center center"
    }
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Elizabeth Pierce")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Web Designer")])]), _vm._v(" "), _c('div', {
    staticClass: "widget-user-image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "User Avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 border-right"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('h5', {
    staticClass: "description-header"
  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("PRODUCTS")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "user-block"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "username"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Mark as read"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('img', {
    staticClass: "img-responsive pad",
    attrs: {
      "src": "/static/img/photo2.png",
      "alt": "Photo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("I took this photo this morning. What do you guys think?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted"
  }, [_vm._v("127 likes - 3 comments")])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer box-comments"
  }, [_c('div', {
    staticClass: "box-comment"
  }, [_c('img', {
    staticClass: "img-circle img-sm",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-text"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
    staticClass: "text-muted pull-right"
  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-comment"
  }, [_c('img', {
    staticClass: "img-circle img-sm",
    attrs: {
      "src": "/static/img/user4-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-text"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("\n                      Luna Stark\n                      "), _c('span', {
    staticClass: "text-muted pull-right"
  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('img', {
    staticClass: "img-responsive img-circle img-sm",
    attrs: {
      "src": "/static/img/user4-128x128.jpg",
      "alt": "Alt Text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-push"
  }, [_c('input', {
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": "Press enter to post comment"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "user-block"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/user1-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "username"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Mark as read"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Far far away, behind the word mountains, far from the\n              countries Vokalia and Consonantia, there live the blind\n              texts. Separated they live in Bookmarksgrove right at")]), _vm._v(" "), _c('p', [_vm._v("the coast of the Semantics, a large language ocean.\n              A small river named Duden flows by their place and supplies\n              it with the necessary regelialia. It is a paradisematic\n              country, in which roasted parts of sentences fly into\n              your mouth.")]), _vm._v(" "), _c('div', {
    staticClass: "attachment-block clearfix"
  }, [_c('img', {
    staticClass: "attachment-img",
    attrs: {
      "src": "/static/img/photo1.png",
      "alt": "Attachment Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attachment-pushed"
  }, [_c('h4', {
    staticClass: "attachment-heading"
  }, [_c('a', {
    attrs: {
      "href": "http://www.lipsum.com/"
    }
  }, [_vm._v("Lorem ipsum text generator")])]), _vm._v(" "), _c('div', {
    staticClass: "attachment-text"
  }, [_vm._v("\n                  Description about the attachment can be placed here.\n                  Lorem Ipsum is simply dummy text of the printing and typesetting industry... "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("more")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted"
  }, [_vm._v("45 likes - 2 comments")])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer box-comments"
  }, [_c('div', {
    staticClass: "box-comment"
  }, [_c('img', {
    staticClass: "img-circle img-sm",
    attrs: {
      "src": "/static/img/user3-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-text"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
    staticClass: "text-muted pull-right"
  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-comment"
  }, [_c('img', {
    staticClass: "img-circle img-sm",
    attrs: {
      "src": "/static/img/user5-128x128.jpg",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-text"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("\n                      Nora Havisham\n                      "), _c('span', {
    staticClass: "text-muted pull-right"
  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                The point of using Lorem Ipsum is that it has a more-or-less\n                normal distribution of letters, as opposed to using\n                'Content here, content here', making it look like readable English.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('img', {
    staticClass: "img-responsive img-circle img-sm",
    attrs: {
      "src": "/static/img/user4-128x128.jpg",
      "alt": "Alt Text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-push"
  }, [_c('input', {
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": "Press enter to post comment"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06492371!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/widgets/Index.vue
// module id = 1336
// module chunks = 2